<template>
   
    <div >
          <!-- Keep-alive should wrap <router-view /> -->
         
    <div class="homepage d-flex flex-column vh-100">
         <!-- navbar -->
         <div class="homepage-navbar bg-light shadow mb-auto p-3 bg-primary" >
            <div class="d-flex align-items-center">
         
                  
                  <span>
                    <img src="../assets/logo.png" style="    width: 150px;">
                  </span>
                  <span  v-if="getCurrentTemperature" class="weather-container">
                    <i class="bi bi-thermometer "></i> {{getCurrentTemperature}}
                  </span>
            
               <div class="d-flex align-items-center gap-2 ms-auto">
                  <a @click="checkUserLogged()" class="link-dark">
                     <div class="bg-dark bg-opacity-75 rounded-circle user-icon"><i class="bi bi-person d-flex m-0 h4 text-white"></i></div>
                  </a>
                  <!-- <a class="toggle" href="#">
                  <b class="bg-dark bg-opacity-75 rounded-circle user-icon">
                  <i class="bi bi-list d-flex m-0 h4 text-white"></i>
                  </b>
                  </a> -->
               </div>
            </div>
            <!-- <div class="pt-3">
               
               <a href="#" data-bs-toggle="offcanvas" data-bs-target="#searchoffcanvas"
                  aria-controls="searchoffcanvas">
                  <div class="input-group bg-white rounded-3 shadow-sm py-1">
                     <input type="text" class="form-control bg-transparent border-0 rounded-0 px-3"
                        placeholder="Search here for more" aria-label="Search here for"
                        aria-describedby="search">
                     <span class="input-group-text bg-transparent border-0 rounded-0 pe-3" id="search"><i
                        class="icofont-search-1"></i></span>
                  </div>
               </a>
            </div> -->
            <div class="pt-3">
               <!-- Search -->
               <div class="input-group bg-white rounded-3 shadow-sm py-1">
                 <input type="text" v-model="searchQuery" class="form-control bg-transparent border-0 rounded-0 px-3"
                   placeholder="Search...." aria-label="Search">
                 <router-link 
                   :to="{ path: '/searchbar', query: { string: searchQuery } }" 
                   class="input-group-text bg-transparent border-0 rounded-0 pe-3">
                   <i class="icofont-search-1"></i>
                 </router-link>
               </div>
             </div>


         </div>
    
         <!-- body -->
         <div class="my-auto overflow-auto vh-100" style="overflow-x: hidden !important;">
            <!-- shop by category -->
            <div class="bg-light pb-0">
               <div class="d-flex align-items-center justify-content-between p-3">
                  <h5 class="fw-bold text-black mb-0">Categories</h5>
                  <!--<a class="text-primary" data-bs-toggle="modal" data-bs-target="#categories" href="#">View all<i class="icofont-rounded-right"></i></a>-->
               </div>
               <div class="all-cate">
                  <div class="col ps-3" v-for="(cat,i) in categories">
                     <router-link :to="'/list?name='+cat.name" class="link-dark">
                        <div class="card bg-transparent border-0 text-center">
                           <img :src="'https://mh13.dktsoft.in/public/uploads/'+cat.img" alt="" class="card-img-top rounded-2 mb-2">
                           <div class="card-body p-0">
                              <!--<p class="card-title   m-0">{{cat.name}}</p>-->
                           </div>
                        </div>
                     </router-link>
                  </div> 
               </div>
            </div>


          <!-- start tops new---------------------------------------------------------------------------------------------------------------->



          <div class="pt-2">
            <div class="d-flex align-items-center justify-content-between px-3 pb-3">
               <h5 class="fw-bold text-black mb-0">News</h5>
               <router-link :to="'/list?name=news'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
               <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
            </div>
            
            <div v-if="loadingNews" class="loading">Loading News...</div>
            <div  v-else class="top-news">
               <!-- 1st item -->
               
               <div class="top-picks-item listItem"  v-for="(data_row,i) in news" style="min-height: 260px;">
                  <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                     <a :href="data_row.link" target="_blank">
                     <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=news`" class="link-dark">-->
                        <div class="bg-light rounded-2 product-box" :style="'background:url('+data_row.img+') top center / cover no-repeat'"> 
                           <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                        </div>
                     <!-- </router-link> -->
                     <!-- <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                        <b>{{data_row.name}}</b><br>
                     </div>
                     <div class="card-body p-0">
                        <small class="text-muted">{{data_row.name}}</small>
                        <h6 class="card-title fw-bold">{{data_row.location}}</h6>                         
                         <p class="card-text text-muted">100 g x 2</p> -->
                     <!-- </div> -->
                     
                     <div v-if="data_row?.category" class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3 twoline">
                        <b>{{data_row.category}}</b> 
                     </div>
                     <div class="card-body p-0">
                        <h6 style="color: black;" class="threeline">{{data_row.name}}</h6>
                        <p class="card-text text-dark">{{data_row?.actualDate}}</p> 
                        <small class="text-muted">{{ data_row.description.substring(0, 30) }}</small>
                        <!-- <h6 class="card-title fw-bold">{{data_row.location}}</h6>                          -->
                        <!-- <p class="card-text text-muted">100 g x 2</p> -->
                     </div>
                  </a>
                     <div
                        class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                        <div>
                           <!-- <del class="small text-muted">$108</del> -->
                           <!-- <h6 class="fw-bold m-0">Rs.{{data_row.cost}}</h6> -->
                        </div>
                        <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=event`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->
                        
                     </div>
                  </div>
               </div>
               
            </div> 
         </div>




          <!-- end top news------------------------------------------------------------------------------------------------------------------------------------------------------->


            <!-- Top Evets -->
            <div class="pt-2 bg_card">
               <div class="d-flex align-items-center justify-content-between px-3 pb-3">
                  <h5 class="fw-bold text-black mb-0">Events</h5>
                  <router-link :to="'/list?name=event'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
                  <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
               </div>
               <div v-if="loadingEvents" class="loading">Loading Events...</div>
            <div  v-else  class="top-events">
                  <!-- 1st item -->
                  <div class="top-picks-item listItem"  v-for="(data_row,i) in events" style="min-height: 270px;">
                     <router-link :to="`/singleeventlist?id=${data_row.id}&name=event`" class="link-dark">
                     <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                           <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'event/'+data_row.img+') top center / cover no-repeat'">
                              <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                           </div>
                        <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                           {{data_row.time}}
                        </div>
                        <div class="card-body p-0">
                          
                           <small  class="text-muted">{{data_row.location}}</small>     
                            <p class="card-title fw-bold">{{data_row.name}}</p>
                           <!-- <p class="card-text text-muted">100 g x 2</p> -->
                        </div>
                        <div
                           class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                           <div>
                              <!-- <del class="small text-muted">$108</del> -->
                              <h6 class="fw-bold m-0" v-if="data_row.cost && data_row.cost!=0">Rs.{{data_row.cost}}</h6>
                           </div>
                           <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=event`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->
                           
                        </div>

                     </div>
                  </router-link>
                  </div>
                  
               </div> 
            </div>

              <!-- start --------------------------------------------------------------------------------------------------------------------------job -->

                     <div class="pt-3">
                        <div class="d-flex align-items-center justify-content-between px-3 pb-3">
                           <h5 class="fw-bold text-black mb-0">Jobs</h5>
                           <router-link :to="'/list?name=job'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
                           <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
                        </div>
                       <div v-if="loadingJobs" class="loading">Loading Jobs...</div>
            <div  v-else class="top-job">
                           <!-- 1st item -->
                           <div class="top-picks-item listItem"  v-for="(data_row,i) in jobs" style="min-height: 240px;">
                              <router-link :to="`/singleeventlist?id=${data_row.id}&name=job`" class="link-dark">
                              <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                                 
                               
                                    <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'jobs/'+data_row.img+') top center / cover no-repeat'">
                                       <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                                    </div>
                                
                                 <div class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                                    {{data_row.jobtype}} 
                                 </div>
                                 <div class="card-body p-0">
                                    <small class="text-muted twoline"> {{data_row.companyname}}</small>
                                    <h6 class="card-title fw-bold twoline"><i class="bi bi-building-fill-check"></i> {{data_row.title}}</h6>                         
                                    <!-- <p class="card-text text-muted">100 g x 2</p> -->
                                 </div>
                                 <div
                                    class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                                    <div>
                                       <!-- <del class="small text-muted">$108</del> -->
                                       <!-- <h6 class="fw-bold m-0">
                                          <i class="bi bi-telephone"></i>
                                          <a :href="'tel:' + data_row.contact" class="text-decoration-none text-dark">{{ data_row.contact }}</a>
                                        </h6> -->
                                        <p class="text-muted" v-if="data_row?.experienceyear">Experience: {{data_row.experienceyear}}</p> 
                                        <p class="text-muted twoline" v-if="data_row?.joblocation"><i class="bi bi-geo-alt-fill"></i> {{data_row.joblocation}}</p>   
                                    </div>
                                    <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=job`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->
                                    
                                 </div>
                              </div>
                           </router-link>
                           </div>
                           
                        </div> 
                     </div>






               <!-- end-------------------------------------------------------------------------------------------------------------------------------------job-->




      <!-- start --------------------------------------------------------------------------------------------------------------------------food -->

            <div class="pt-3 bg_card">
               <div class="d-flex align-items-center justify-content-between px-3 pb-3">
                  <h5 class="fw-bold text-black mb-0">Food</h5>
                  <router-link :to="'/list?name=food'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
                  <!-- <a class="text-primary" href="eventlist">View all<i class="icofont-rounded-right"></i></a> -->
               </div>
              <div v-if="loadingFood" class="loading">Loading Food...</div>
            <div  v-else class="top-food">
                  <!-- 1st item -->
                  <div class="top-picks-item listItem"  v-for="(data_row,i) in food" style="min-height: 235px;">
                     <router-link :to="`/singleeventlist?id=${data_row.id}&name=food`" class="link-dark">
                     <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                       
                           <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'food/'+data_row.img+') top center / cover no-repeat'">
                              <!--<img :src="$asset_path+'event/'+event.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                           </div>
                    
                        <div v-if="data_row.catname" class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                           <b>{{data_row.catname}}</b><br>
                        </div>
                        <div class="card-body p-0">
                           <h6 class="card-title fw-bold text-dark twoline">{{data_row.name}}</h6>   
                           <small class="text-muted twoline">{{data_row.description}}</small>                      
                           <!-- <p class="card-text text-muted">100 g x 2</p> -->
                        </div>
                        <div
                           class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                           <div>
                              <!-- <del class="small text-muted">$108</del> -->
                              <!-- <h6 class="fw-bold m-0">
                                 <i class="bi bi-telephone"></i>
                                 <a :href="'tel:' + data_row.contact" class="text-decoration-none text-dark">{{ data_row.mobile }}</a>
                              </h6> -->
                              <p class="card-title fw-bold twoline"><i class="bi bi-geo-alt"></i>{{data_row.location}}</p> 
                           </div>
                           <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=food`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->
                           
                        </div>
                     </div>
                  </router-link>
                  </div>
                  
               </div> 
            </div>






      <!-- end-------------------------------------------------------------------------------------------------------------------------------------food-->


      <div class="pt-3 mb-1">
         <div class="d-flex align-items-center justify-content-between px-3 pb-3">
            <h5 class="fw-bold text-black mb-0">Trending Properties</h5>
            <router-link :to="'/list?name=property'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
         </div>
         <div v-if="loadingProperties" class="loading">Loading Properties...</div>
            <div  v-else  class="top-properties ">
            <!-- 1st item -->
            <div class="top-picks-item listItem  pb-3"  v-for="(data_row,i) in properties"  style="min-height: 200px; border: 1px solid #b2b2b2;    box-shadow: 0px 0px !important;">
               <router-link :to="`/singleeventlist?id=${data_row.id}&name=property`" class="link-dark">
               <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                
                        <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'property/'+data_row.img+') top center / cover no-repeat'"> 
                         <!--<img :src="$asset_path+'property/'+data_row.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                     </div>
                 
                   <div v-if="data_row.offer" class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                     <b>{{data_row.offer}}<i class="bi bi-percent"></i></b><br>
                  </div> 
                  <div class="card-body p-0">
                     <small class="text-muted twoline">{{data_row.name}}</small>
                     <h6 class="card-title fw-bold twoline">{{data_row.description}}</h6>
                     <p class="card-text text-muted">{{data_row.feet}}.Sq/feet</p>
                  </div>
                  <div
                     class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                     <!-- <div>
                        <del class="small text-muted">$108</del>
                        <h6 class="fw-bold m-0">$106</h6>
                     </div> -->
                     <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=property`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->

                  </div>
               </div>
            </router-link>
            </div>
            
         </div> 
      </div>













            <!-- Top Picks -->
            <div class="pt-3 bg_card">
               <div class="d-flex align-items-center justify-content-between px-3 pb-3">
                  <h5 class="fw-bold text-black mb-0">Trending Business</h5>
                  <router-link :to="'/list?name=business'" class="text-primary">View all<i class="icofont-rounded-right"></i></router-link>
               </div>
               <div v-if="loadingListings" class="loading">Loading Business...</div>
            <div  v-else  class="top-picks">
                  <!-- 1st item -->
                  <div class="top-picks-item listItem"  v-for="(data_row,i) in listings"   style="min-height: 200px; border: 1px solid #b2b2b2;    box-shadow: 0px 0px !important;">
                     <router-link :to="`/singleeventlist?id=${data_row.id}&name=business`" class="link-dark">
                     <div class="card bg-transparent border-0 overflow-hidden h-100 p-1">
                    
                             <div class="bg-light rounded-2 product-box" :style="'background:url('+$asset_path+'business/'+data_row.img+') top center / cover no-repeat'"> 
                               <!--<img :src="$asset_path+'business/'+business.img"  alt="" class="img-fluid w-75 d-block mx-auto">-->
                           </div>
                      
                        <div v-if="data_row.offer" class="bg-info position-absolute top-0 text-white osahan-badge text-center mx-3">
                           <b>{{data_row.offer}}<i class="bi bi-percent"></i></b><br>
                        </div>
                        <div class="card-body p-0">
                           <small class="text-muted twoline">{{data_row.catname}}</small>
                           <h6 class="card-title fw-bold twoline">{{data_row.name}}</h6>
                           <!-- <p class="card-text text-muted">100 g x 2</p> -->
                        </div>
                        <div
                           class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">
                           <!-- <div>
                              <del class="small text-muted">$108</del>
                              <h6 class="fw-bold m-0">$106</h6>
                           </div> -->
                           <!-- <router-link :to="`/singleeventlist?id=${data_row.id}&name=business`" class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">View</router-link> -->

                        </div>
                     </div>
                  </router-link>
                  </div>
                  
               </div> 
            </div>
             <!-- Top Picks -->
            
            <!-- coupons -->
            <!--<div class="bg-warning">-->
            <!--   <h5 class="fw-bold text-black mb-0 p-3">Save more with coupons</h5>-->
            <!--   <div>-->
            <!--      <div class="coupons">-->
            <!--         <div class="coupons-item">-->
            <!--            <div class="link-dark pb-3 ps-3">-->
            <!--               <div class="d-flex align-items-center gap-3 shadow-sm rounded-2 p-3 bg-white">-->
            <!--                  <i class="icofont-sale-discount icofont-2x text-success"></i>-->
            <!--                  <div>-->
            <!--                     <h6 class="fw-bold osahan-mb-1">Flat $100 off</h6>-->
            <!--                     <p class="small text-muted text-uppercase mb-0">Use Helloim | on orders-->
            <!--                        above $400-->
            <!--                     </p>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--         <div class="coupons-item">-->
            <!--            <div class="link-dark pb-3 ps-3">-->
            <!--               <div class="d-flex align-items-center gap-3 shadow-sm rounded-2 p-3 bg-white">-->
            <!--                  <i class="icofont-sale-discount icofont-2x text-success"></i>-->
            <!--                  <div>-->
            <!--                     <h6 class="fw-bold osahan-mb-1">Flat $100 off</h6>-->
            <!--                     <p class="small text-muted text-uppercase mb-0">Use Savebig | on orders-->
            <!--                        above $999-->
            <!--                     </p>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--         <div class="coupons-item">-->
            <!--            <div class="link-dark pb-3 ps-3">-->
            <!--               <div class="d-flex align-items-center gap-3 shadow-sm rounded-2 p-3 bg-white">-->
            <!--                  <i class="icofont-sale-discount icofont-2x text-success"></i>-->
            <!--                  <div>-->
            <!--                     <h6 class="fw-bold osahan-mb-1">15% off upto $124</h6>-->
            <!--                     <p class="small text-muted text-uppercase mb-0">Use Citi125 | orders-->
            <!--                        above $750-->
            <!--                     </p>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--         <div class="coupons-item">-->
            <!--            <div class="link-dark pb-3 ps-3">-->
            <!--               <div class="d-flex align-items-center gap-3 shadow-sm rounded-2 p-3 bg-white">-->
            <!--                  <i class="icofont-sale-discount icofont-2x text-success"></i>-->
            <!--                  <div>-->
            <!--                     <h6 class="fw-bold osahan-mb-1">10% off upto $150</h6>-->
            <!--                     <p class="small text-muted text-uppercase mb-0">Use hdfc150 | orders-->
            <!--                        above $1250-->
            <!--                     </p>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--         <div class="coupons-item">-->
            <!--            <div class="link-dark pb-3 ps-3">-->
            <!--               <div class="d-flex align-items-center gap-3 shadow-sm rounded-2 p-3 bg-white">-->
            <!--                  <i class="icofont-sale-discount icofont-2x text-success"></i>-->
            <!--                  <div>-->
            <!--                     <h6 class="fw-bold osahan-mb-1">Flat $150 off</h6>-->
            <!--                     <p class="small text-muted text-uppercase mb-0">Use federalim | orders-->
            <!--                        above $499-->
            <!--                     </p>-->
            <!--                  </div>-->
            <!--               </div>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
            <!--   </div>-->
            <!--</div>-->
            <!-- must have items -->
            <!--<div class="py-3">-->
            <!--   <h5 class="fw-bold text-black mb-0 px-3 pb-3">Must Have Items</h5>-->
            <!--   <div class="top-picks">-->
                  <!-- 1st item -->
            <!--      <div class="top-picks-item">-->
            <!--         <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3">-->
            <!--            <a href="product-detail.html" class="link-dark">-->
            <!--               <div class="bg-light rounded-2 p-4 position-relative product-box">-->
            <!--                  <img src="../assets/img/amul-butter.png" alt="" class="img-fluid h-100 d-block mx-auto">-->
            <!--               </div>-->
            <!--            </a>-->
            <!--            <div class="bg-success position-absolute top-0 text-white osahan-badge text-center mx-3">-->
            <!--               <b>2%</b><br>OFF-->
            <!--            </div>-->
            <!--            <div class="card-body p-0">-->
            <!--               <small class="text-muted">Amul</small>-->
            <!--               <h6 class="card-title fw-bold">Pasteuised Butter Pack of 2</h6>-->
            <!--               <p class="card-text text-muted">100 g x 2</p>-->
            <!--            </div>-->
            <!--            <div-->
            <!--               class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
            <!--               <div>-->
            <!--                  <del class="small text-muted">$108</del>-->
            <!--                  <h6 class="fw-bold m-0">$106</h6>-->
            <!--               </div>-->
            <!--               <a href="cart.html"-->
            <!--                  class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
                  <!-- 2nd item -->
            <!--      <div class="top-picks-item">-->
            <!--         <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3">-->
            <!--            <a href="product-detail.html" class="link-dark">-->
            <!--               <div class="bg-light rounded-2 p-2 position-relative product-box">-->
            <!--                  <img src="../assets/img/fortune-oil.png" alt="" class="img-fluid h-100 d-block mx-auto">-->
            <!--               </div>-->
            <!--            </a>-->
            <!--            <div class="bg-success position-absolute top-0 text-white osahan-badge text-center mx-3">-->
            <!--               <b>4%</b><br>OFF-->
            <!--            </div>-->
            <!--            <div class="card-body p-0">-->
            <!--               <small class="text-muted">Fortune</small>-->
            <!--               <h6 class="card-title fw-bold">Soya Refined Soybean Oil</h6>-->
            <!--               <p class="card-text text-muted">1 L</p>-->
            <!--            </div>-->
            <!--            <div-->
            <!--               class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
            <!--               <div>-->
            <!--                  <del class="small text-muted">$180</del>-->
            <!--                  <h6 class="fw-bold m-0">$173</h6>-->
            <!--               </div>-->
            <!--               <a href="cart.html"-->
            <!--                  class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
                  <!-- 3rd item -->
            <!--      <div class="top-picks-item">-->
            <!--         <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3">-->
            <!--            <a href="product-detail.html" class="link-dark">-->
            <!--               <div class="bg-light rounded-2 p-2 position-relative product-box">-->
            <!--                  <img src="../assets/img/kachighani-oil.png" alt="" class="img-fluid h-100 d-block mx-auto">-->
            <!--               </div>-->
            <!--            </a>-->
            <!--            <div class="bg-danger position-absolute top-0 text-white osahan-badge text-center mx-3">-->
            <!--               <b>4%</b><br>OFF-->
            <!--            </div>-->
            <!--            <div class="card-body p-0">-->
            <!--               <small class="text-muted">Fortune</small>-->
            <!--               <h6 class="card-title fw-bold">Kachi Ghani Pure Mustard Oil</h6>-->
            <!--               <p class="card-text text-muted">1 L</p>-->
            <!--            </div>-->
            <!--            <div-->
            <!--               class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
            <!--               <div>-->
            <!--                  <del class="small text-muted">$196</del>-->
            <!--                  <h6 class="fw-bold m-0">$188</h6>-->
            <!--               </div>-->
            <!--               <a href="cart.html"-->
            <!--                  class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
                  <!-- 4rth item -->
            <!--      <div class="top-picks-item">-->
            <!--         <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3">-->
            <!--            <a href="product-detail.html" class="link-dark">-->
            <!--               <div class="bg-light rounded-2 p-2 product-box">-->
            <!--                  <img src="../assets/img/uncle-chips.png" alt="" class="img-fluid h-100 d-block mx-auto">-->
            <!--               </div>-->
            <!--            </a>-->
            <!--            <div class="card-body p-0">-->
            <!--               <small class="text-muted">Uncle Chipps</small>-->
            <!--               <h6 class="card-title fw-bold">Spicy Treat Sweet Chipps</h6>-->
            <!--               <p class="card-text text-muted">50 g</p>-->
            <!--            </div>-->
            <!--            <div-->
            <!--               class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
            <!--               <div>-->
            <!--                  <del class="small text-muted">$25</del>-->
            <!--                  <h6 class="fw-bold m-0">$20</h6>-->
            <!--               </div>-->
            <!--               <a href="cart.html"-->
            <!--                  class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
                  <!-- 5th item -->
            <!--      <div class="top-picks-item">-->
            <!--         <div class="card bg-transparent border-0 overflow-hidden h-100 ps-3 pe-1">-->
            <!--            <a href="product-detail.html" class="link-dark">-->
            <!--               <div class="bg-light rounded-2 p-2 product-box">-->
            <!--                  <img src="../assets/img/tata-gold.png" alt="" class="img-fluid h-100 d-block mx-auto">-->
            <!--               </div>-->
            <!--            </a>-->
            <!--            <div class="card-body p-0">-->
            <!--               <small class="text-muted">Tata</small>-->
            <!--               <h6 class="card-title fw-bold">Tata Gold with 15% Long Leaves</h6>-->
            <!--               <p class="card-text text-muted">750 g</p>-->
            <!--            </div>-->
            <!--            <div-->
            <!--               class="card-footer bg-transparent border-0 d-flex align-items-center justify-content-between p-0">-->
            <!--               <div>-->
            <!--                  <del class="small text-muted">$470</del>-->
            <!--                  <h6 class="fw-bold m-0">$323</h6>-->
            <!--               </div>-->
            <!--               <a href="cart.html"-->
            <!--                  class="btn btn-outline-success fw-bold rounded-3 shadow-sm btn-sm">ADD</a>-->
            <!--            </div>-->
            <!--         </div>-->
            <!--      </div>-->
            <!--   </div>-->
            <!--</div>-->
            <!-- banner -->
            <!--<div class="p-3 bg-light">-->
            <!--   <div class="rounded-2 ps-4 pt-4 shadow-sm d-flex gap-1 align-items-center bg-warning bg-gradient justify-content-between">-->
            <!--      <div class="pb-4">-->
            <!--         <h1 class="fw-bolder text-black display-5 mb-1">50% OFF</h1>-->
            <!--         <p class="text-dark">Special Offer: Get 50% Cashback + <span class="text-success"><i class="bi bi-basket"></i> Free Delivery</span>-->
            <!--         <b class="bg-primary px-1 rounded-1 small text-uppercase fw-bold text-white mt-1 d-inline-block">New Users</b></p>-->
            <!--         <a href="listing.html" class="btn btn-light text-success fw-bold rounded-3 shadow-sm btn-sm border-0">SHOP NOW</a>-->
            <!--      </div>-->
            <!--      <img src="../assets/img/banner1.png" alt="" class="img-fluid mt-auto osahan-offer-banner">-->
            <!--   </div>-->
            <!--</div>-->
         </div>
         <!-- category button -->
         <div class="btn-category" v-if="isbutton">
            <a @click="checkUserLogged()"  >
               <img src="../assets/addbtn.png" style="    width: 110px;">
            </a>
         </div>
         <!--   -->
         <div class="footer bg-white shadow mt-auto border-TOP footer_bar">
            <div class="d-flex align-items-center justify-content-between py-1 footer_menu">
                  <router-link :to="'/'" class="link-dark text-center col py-2 p-1">
                  <!--<i class="bi bi-house h3 m-0"></i>-->
                   <img :src="'https://mh13.dktsoft.in/public/uploads/cat_img/menu_home.png'" alt="" class="card-img-top rounded-2 mb-2">
                  <p class="small m-0 pt-1">Home</p>
               </router-link>
               <router-link :to="'/categorylist'" class="link-dark text-center col py-2 p-1">
                  <!--<i class="bi bi-shop h3 m-0"></i>-->
                  <img :src="'https://mh13.dktsoft.in/public/uploads/cat_img/cat_home.png'" alt="" class="card-img-top rounded-2 mb-2">
                  <p class="small m-0 pt-1">Category</p>
               </router-link>
               <router-link :to="'/emergencylist'" class="link-dark text-center col py-2 p-1">
                  <!--<i class="bi bi-exclamation-square-fill  h3 m-0"></i>-->
                  <img :src="'https://mh13.dktsoft.in/public/uploads/cat_img/emer_home.png'" alt="" class="card-img-top rounded-2 mb-2">
                  <p class="small m-0 pt-1">Emergency</p>
               </router-link>
               <router-link :to="'/dailyneed'" class="link-dark text-center col py-2 p-1">
                  <!--<i class="bi bi-clock-history h3 m-0"></i>-->
                  <img :src="'https://mh13.dktsoft.in/public/uploads/cat_img/daily_home.png'" alt="" class="card-img-top rounded-2 mb-2">
                  <p class="small m-0 pt-1">Daily Needs</p>
               </router-link>
               <a @click="checkUserprofile()" class="text-muted text-center col py-2 p-1">
                  <!--<i class="bi bi-person h3 m-0"></i>-->
                  <img :src="'https://mh13.dktsoft.in/public/uploads/cat_img/prof_home.png'" alt="" class="card-img-top rounded-2 mb-2">
                  <p class="small m-0 pt-1">Profile</p>
               </a>
            </div>
         </div>
      </div>
    </div>
</template>
<style>
.btn-category{
    position: absolute;
    bottom: 6.5rem;
    right: 0.2em;
}
.weather-container {
  text-align: center;
    font-family: Arial, sans-serif;
    padding: 4px 20px;
    background: #f4f4f4;
    margin: auto;
    
    border-radius: 10px;
}
.bg_card{
  background: #ededec;
    margin: 10px 0px;
    padding-bottom: 10px;
}
.all-cate  .card-title{
        text-transform: capitalize;
        font-weight: 600;
}
.listItem{
     position: relative;
    background: #fff;
    border-radius: 15px;
    overflow: hidden;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
    transition: transform 0.3s ease-in-out;
    margin: 0px 5px;
    border-radius: 5px;
}
.plus-color{
   background: linear-gradient(328deg, #ff0000, #000199);
}
.spinner-container {
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
  z-index: 9999;
}

.spinner {
  width: 50px;
  height: 50px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top: 5px solid #ffffff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
    .twoline{
            /*height: 38px;*/
            max-height: 38px;
    overflow: hidden;
    }
    .threeline{
            /*height: 38px;*/
            max-height: 60px;
            overflow: hidden;
    }

</style>
<style scoped>
    h5{
            font-weight: 800 !important;
    }
    .loading{
        text-align: center;
    font-weight: 600;
    color: brown;
    }
</style>

<script> 
import axios from "@/plugins/axios";  
import {
  fetchCategories,
  fetchEvents,
  fetchNews,
  fetchJobs,
  fetchFood,
  fetchListings,
  fetchProperties,
  fetchUserProfile,
  fetchRSS,
  fetchTemperature,
} from  "@/plugins/apiService";


export default {
  name: 'HomeView',
  components: { 
  },
   
  mounted() {
      
    // this.initializeHomeContent();
      var $main_nav = $('#main-nav');
    var $toggle = $('.toggle');
    var defaultOptions = {
        disableAt: false,
        customToggle: $toggle,
        levelSpacing: 40,
        navTitle: 'App',
        levelTitles: true,
        levelTitleAsBack: true,
        pushContent: '#container',
        insertClose: 2
    };
    var Nav = $main_nav.hcOffcanvasNav(defaultOptions);
    
   //  this.fetchWeather();
     this.getHomeBasic(); // Call the method here
    //  this.enterFullscreen();
     
},
  data() {
    return {
      isbutton:false,
      loading:false,
      error:null,
      isUserLogged:false,
      
      loadingCategories: true,
      loadingListings: true,
      loadingEvents: true,
      loadingNews: true,
      loadingJobs: true,
      loadingProperties: true,
      loadingFood: true,
    
    
      profile:[],
      categories:[],
      listings:[],
      events:[],
      tempdata:[],
      news:[],
      jobs:[],
      food:[],
      searchQuery: "", // Stores the search input value
      properties:[],
        current_temperature:0,
     


    }
  },
  methods:{
      initializeSlick(selector) {
          this.$nextTick(() => {
            const $carousel = $(selector);
        
            if ($carousel.hasClass('slick-initialized')) {
              $carousel.slick('unslick');
            }
        
            $carousel.slick({
              slidesToShow: selector==".all-cate"?5:2,
              slidesToScroll: 1,
              autoplay: true,
              autoplaySpeed: 3000,
              dots: false, rows: selector==".all-cate"?1:1, 
              arrows: false
            });
          });
        },


       enterFullscreen() {
      const elem = document.documentElement;
      if (elem.requestFullscreen) {
        elem.requestFullscreen();
      } else if (elem.webkitRequestFullscreen) {
        elem.webkitRequestFullscreen();
      } else if (elem.msRequestFullscreen) {
        elem.msRequestFullscreen();
      }
    }
    ,
    initializeHomeContent(){
      this.$nextTick(() => {
if ($('.coupons').hasClass('slick-initialized')) {
    $('.coupons').slick('unslick');
}
if ($('.top-picks').hasClass('slick-initialized')) {
    $('.top-picks').slick('unslick');
}
if ($('.top-events').hasClass('slick-initialized')) {
    $('.top-events').slick('unslick');
}
if ($('.top-properties').hasClass('slick-initialized')) {
    $('.top-properties').slick('unslick');
}
if ($('.all-cate').hasClass('slick-initialized')) {
    $('.all-cate').slick('unslick');
}
if ($('.product-slider').hasClass('slick-initialized')) {
    $('.product-slider').slick('unslick');
} 

if ($('.top-news').hasClass('slick-initialized')) {
    $('.top-news').slick('unslick');
}

if ($('.top-job').hasClass('slick-initialized')) {
    $('.top-job').slick('unslick');
}

if ($('.top-food').hasClass('slick-initialized')) {
    $('.top-food').slick('unslick');
}


$('.top-job').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 2,
    });
$('.top-food').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 2,
    });

    $('.top-news').slick({
        infinite: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 2.2,
        slidesToScroll: 2,
    });


    // Coupons
        // centerMode: true,
    $('.coupons').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 1.3,
        slidesToScroll: 1,
    });

    // Top Picks - Homepage
    $('.top-picks').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });
    $('.top-properties').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });
    $('.top-events').slick({
        infinite: false,
        arrows: false,
        autoplay: true,
        slidesToShow: 2.3,
        slidesToScroll: 1,
    });

    // All Categories - Homepage
    $('.all-cate').slick({
        infinite: false,
        arrows: true,
        autoplay: true,
        slidesToShow: 4.5,
        slidesToScroll: 3,
        
    });

    // Product Detail
    $('.product-slider').slick({
        arrows: false,
        autoplay: true,
        infinite: false,
        dots: true,
    });
    // this.getHomeBasic();
      });
    }
,

checkUserLogged(){
  if(!this.isUserLogged){
         this.$router.push({ name: 'register' });
   } else if(this.isUserLogged){
      this.$router.push({ name: 'form' });
    }else{

    }
},
checkUserprofile(){
  if(!this.isUserLogged){
         this.$router.push({ name: 'register' });
   } else if(this.isUserLogged){
      this.$router.push({ name: 'profile' });
    }else{

    }
},


// async fetchWeather() {
//         this.loading = true;
//         this.error = null;
  
//         try {
//            var self=this;
//             axios.get("gettempdata").then((response) => {
//             self.tempdata = response.data.tempdata;

            
        
//           }).then(() => {
//                self.initializeHomeContent();
//           }).catch((err) => {
            
//           });;
         

//         } catch (err) {
      
//         } finally {
   
//         }
//       }, 


//loadingCategories,loadingListings
 
    async getHomeBasic() {
        this.loading = true;
        this.error = null;
        var self=this;
           fetchEvents() .then((res) => {this.events = res.data;}).catch(() => {this.error = "Failed to load events.";}).finally(() => {this.loadingEvents = false;this.initializeSlick('.top-events');});
           fetchCategories() .then((res) => {this.categories = res.data;}).catch(() => {this.error = "Failed to load categories.";}).finally(() => {this.loadingCategories = false;this.initializeSlick('.all-cate');});
           fetchNews() .then((res) => {this.news = res.data;}).catch(() => {this.error = "Failed to load news.";}).finally(() => {this.loadingNews = false;this.initializeSlick('.top-news');});
           fetchJobs() .then((res) => {this.jobs = res.data;}).catch(() => {this.error = "Failed to load jobs.";}).finally(() => {this.loadingJobs = false;this.initializeSlick('.top-job');});
           fetchFood() .then((res) => {this.food = res.data;}).catch(() => {this.error = "Failed to load food.";}).finally(() => {this.loadingFood = false;this.initializeSlick('.top-food');});
           fetchListings() .then((res) => {this.listings = res.data;}).catch(() => {this.error = "Failed to load Listings.";}).finally(() => {this.loadingListings = false;this.initializeSlick('.top-picks');});
           fetchProperties() .then((res) => {this.properties = res.data;}).catch(() => {this.error = "Failed to load Properties.";}).finally(() => {this.loadingProperties = false;this.initializeSlick('.top-properties');});
           fetchUserProfile() .then((res) => {this.profile = userProfileRes.data.profile;this.isUserLogged = userProfileRes.data.isUserLogged; }).catch(() => {this.error = "Failed to load events.";}).finally(() => {this.loadingEvents = false;this.initializeSlick('.events-carousel');});
           fetchTemperature() .then((res) => {this.getCurrentTemperature = res.data;}).catch(() => {this.error = "Failed to load Temperature.";}).finally(() => {});
          
           
           
           
           self.isbutton=false;
             
        // try {
        //   var self=this;
        //     axios.post("getfrontview").then((response) => {
        //     self.categories = response.data.app_categories;
        //     self.events = response.data.events;
        //     self.news = response.data.news;
        //     self.jobs = response.data.jobs;
        //     self.food = response.data.food; 
        //     self.listings = response.data.businesslisting;
        //     self.properties = response.data.properties;
        //     self.isUserLogged=response.data.isUserLogged;
        //     self.profile = response.data.profile;
        //     self.fetchRSS = response.data.fetchRSS;
        //     self.getCurrentTemperature = response.data.getCurrentTemperature;
        //     // document.title =response.data.title;
        //     self.isbutton=true;
        //      self.updateMetaTags(response.data.datarow);
        
        //   }).then(() => {
        //       self.initializeHomeContent();
        //   }).catch((err) => {
            
        //   });;
         

        // } catch (err) {
        //   this.error = err.response?.data?.message || "Login failed. Please try again.";
        // } finally {
        //   this.loading = false;
        // }
      }, 


      filterList() {
         alert(searchQuery);
      console.log("Filter function triggered!");
      // Implement your filtering logic here
    },


updateMetaTags(datarow) {
          document.title = datarow.title;// || "MH13 City Directory";
          
          const shortDesc = datarow.description.length > 160 ? datarow.description.slice(0, 157) + "..." : datarow.description;
          
          this.setMetaTag("property", "og:title", datarow.name);
          this.setMetaTag("property", "og:description", shortDesc);
          this.setMetaTag("property", "og:image", `${this.$asset_path}${datarow.img}`);
          this.setMetaTag("property", "og:url", this.currentUrl);
          this.setMetaTag("property", "og:type", "website");
          this.setMetaTag("name", "twitter:card", "summary_large_image");
          this.setMetaTag("name", "twitter:title", datarow.name);
          this.setMetaTag("name", "twitter:description", shortDesc);
          this.setMetaTag("name", "twitter:image", `${this.$asset_path}${datarow.img}`);
        },
    
        setMetaTag(attr, name, content) {
          let tag = document.querySelector(`meta[${attr}='${name}']`);
          if (!tag) {
            tag = document.createElement("meta");
            tag.setAttribute(attr, name);
            document.head.appendChild(tag);
          }
          tag.setAttribute("content", content || "");
        },


  }
}






</script>
